import { PurchaserExportWrapper } from '../../components'

export default function PurchaserExportPage() {
  return <PurchaserExportWrapper />
}
